export default __webpack_public_path__ + "static/media/USRDS_Logo_Acronym.5834fca9.svg";